import helpers from '../helpers';
import modal from './modal';

function setContent($popup, id, modalID) {
	return new Promise((resolve) => {
		let html;
		const content = window.data.popups ? window.data.popups[id] : false;

		if (content) {
			if (content.media) {
				const img = new Image();

				img.onload = () => {
					html = `
						<picture class="map-popup__media">
							<img src="${img.src}" alt="${content.title}" />
						</picture>

						<div class="map-popup__title">${content.title}</div>
						${content.text ? `<div class="map-popup__text">${content.text}</div>` : ''}

						<button class="map-info__button btn js-modal-open" type="button" data-modal="${modalID}" data-modal-id="${id}">
							<span>Подробнее</span>
							<svg><use xlink:href="./images/sprites.svg#arrow-right"></use></svg>
						</button>
					`;

					$popup.find('.map-popup__content').html(html);

					resolve();
				};

				img.src = `${window.baseDir}images/popups/${id}.png`;
			} else {
				html = `
					<div class="map-popup__title">${content.title}</div>

					${content.text ? `<div class="map-popup__text">${content.text}</div>` : ''}

					<button class="map-info__button btn js-modal-open" type="button" data-modal="${modalID}" data-modal-id="${id}">
						<span>Подробнее</span>
						<svg><use xlink:href="./images/sprites.svg#arrow-right"></use></svg>
					</button>
				`;

				$popup.find('.map-popup__content').html(html);

				resolve();
			}
		}
	});
}

function setPositions($point, $popup) {
	if (helpers.isMobile()) {
		$('.map-popup-bg').addClass('is-active');
		$popup.addClass('is-active');
		helpers.lockScroll(true, $popup, 'popup');
		helpers.$body.css('padding-right', `${helpers.getScrollbarWidth()}px`);
		helpers.$header.css('right', `${helpers.getScrollbarWidth()}px`);

		return;
	}

	const offset = 10;
	const pointParams = $point.get(0).getBoundingClientRect();

	let x = pointParams.right + offset;
	let y = pointParams.top - offset;

	// если правая позиция выходит за пределы экрана, то смещаем левее
	if (x + $popup.innerWidth() + offset >= window.innerWidth) {
		x = pointParams.left - offset - $popup.innerWidth();
	}

	// если левая позиция выходит за пределы экрана, то смещаем правее
	if (x <= 1) {
		x = pointParams.right + offset + $popup.innerWidth();
	}

	// если нижняя позиция уходит за пределы экрана, то смещаем выше
	if (pointParams.bottom + offset + $popup.innerHeight() >= innerHeight) {
		y = pointParams.bottom - offset - $popup.innerHeight();
	}

	// если верхняя позиция уходит за пределы экрана, то смещаем ниже
	if (y <= 1) {
		y = offset;
	}

	$popup.addClass('is-active');
	$popup.css({
		left: x,
		top: y,
	});
}

function openPopup($point, $popup) {
	const id = $point.data('popup');
	const modalID = $point.data('modal-id');

	if (id === 'info') {
		setPositions($point, $popup);
	} else if (id === 'free') {
		setPositions($point, $popup);
	} else {
		setContent($popup, id, modalID).then(() => {
			setPositions($point, $popup);
		});
	}
}

function closePopup($popup) {
	$popup.removeClass('is-active');
	$('.map-popup-bg').removeClass('is-active');

	if (helpers.isMobile()) {
		helpers.$body.css('padding-right', '');
		helpers.$header.css('right', '');
		helpers.lockScroll(false, $popup, 'popup');
	}
}

function init() {
	$('.js-map-point').on('click.popup', (e) => {
		if (!helpers.isMobile()) {
			return;
		}
		e.preventDefault();
		e.stopPropagation();

		const id = $(e.currentTarget).data('modal-id');
		const modalID = $(e.currentTarget).data('popup');

		modal.open(id, modalID);
	});

	$('.map__point').on('mouseenter.popup', (e) => {
		if (helpers.isMobile()) {
			return;
		}

		const $point = $(e.currentTarget);
		const $popup = $('.map-popup');
		const $popup2 = $('.map-info');
		const $popup3 = $('.map-free');

		if ($point.hasClass('js-modal-open')) {
			// очень сложно кликнуть по кнопке “Подробнее” в некоторых попапах
			// https://docs.google.com/document/d/1MSGQ1_dfYiELIjPe4xkOHAUGCLNZ7fpJ47hsApZStF8

			// closePopup($popup);
			// closePopup($popup2);
			// closePopup($popup3);
		} else {
			closePopup($popup2);
			closePopup($popup3);
			openPopup($point, $popup);
		}
	});

	$('.js-map-info').on('click.popup', (e) => {
		if (!helpers.isMobile()) {
			return;
		}

		const $point = $(e.currentTarget);
		const $popup = $('.map-info');
		openPopup($point, $popup);
	});

	$('.js-map-info').on('mouseenter.popup', (e) => {
		if (helpers.isMobile()) {
			return;
		}

		const $point = $(e.currentTarget);
		const $popup = $('.map-info');
		const $popup2 = $('.map-popup');
		const $popup3 = $('.map-free');

		closePopup($popup2);
		closePopup($popup3);
		openPopup($point, $popup);
	});

	$('.js-map-free').on('click.popup', (e) => {
		if (!helpers.isMobile()) {
			return;
		}

		const $point = $(e.currentTarget);
		const $popup = $('.map-free');
		openPopup($point, $popup);
	});

	$('.js-map-free').on('mouseenter.popup', (e) => {
		if (helpers.isMobile()) {
			return;
		}

		const $point = $(e.currentTarget);
		const $popup = $('.map-free');
		const $popup2 = $('.map-popup');
		const $popup3 = $('.map-info');

		closePopup($popup2);
		closePopup($popup3);
		openPopup($point, $popup);
	});

	$('.map-popup__close, .map-info__close, .map-popup-bg').on('click.popup', (e) => {
		let $popup = $(e.currentTarget).closest('.js-popup');

		if (!$popup.length) {
			$popup = $('.js-popup');
		}

		closePopup($popup);
	});

	helpers.$window.on('scroll.popup', () => {
		if (helpers.isMobile()) {
			return;
		}

		if ($('.js-popup').hasClass('is-active')) {
			const $popup = $('.js-popup');

			closePopup($popup);
		}
	});
}

export default {
	init,
	openPopup,
	closePopup,
};
